import { render, staticRenderFns } from "./ControlCafes.vue?vue&type=template&id=42311698&scoped=true"
import script from "./ControlCafes.vue?vue&type=script&lang=js"
export * from "./ControlCafes.vue?vue&type=script&lang=js"
import style0 from "./ControlCafes.vue?vue&type=style&index=0&id=42311698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42311698",
  null
  
)

export default component.exports